import Vue from 'vue'
import Vuex from 'vuex'
import xtend from 'xtend'
import cartModule from './modules/cart'
import authModule from 'inomph-auth'
import configModule from './modules/config'
import customerModule from './modules/customer'
import modalModule from 'vue-modal/dist/vue-modal-store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuex)
Vue.use(Vuetify)

export default function (appConfig) {
  const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state: {
      user: null,
      categories: null
      // config: {
      //   provincialShippingFee: 0,
      //   giftWrappingFee: 0
      // }
    },
    getters: {
      customer: function (state) {
        return state.user ? state.user.customer : null
      }
    },
    mutations: {
      // setConfig: function (state, config) {
      //   state.config = config
      // },
      setCategories: function (state, categories) {
        state.categories = categories
      },
      setUser (state, user) {
        state.user = user
      },
      setCustomerDetails: function (state, customerDetails) {
        if (state.user && state.user.uid === customerDetails.key) {
          const existingCustomerDetails = state.user.customer || {}
          Vue.set(
            state.user,
            'customer',
            xtend(existingCustomerDetails, customerDetails)
          )
        }
      }
    },
    actions: {
      userChanged (context, user) {
        context.commit('setUser', user)
        context.dispatch('customer/userChanged', user)
        context.dispatch('cart/userChanged', user)
      }
    }
  })
  store.registerModule('auth', authModule({endpoint: `${appConfig.API_URL}/auth/token`}))
  store.registerModule('modal', modalModule(Vue))
  // store.registerModule('modal', modalModule())
  store.registerModule('cart', cartModule(appConfig))
  store.registerModule('config', configModule(appConfig))
  store.registerModule('customer', customerModule(appConfig))
  store.dispatch('auth/restore')
  store.dispatch('customer/restore')
  store.dispatch('config/initialize')
  store.dispatch('cart/restoreCart')
  return store
}



// WEBPACK FOOTER //
// ./src/store/index.js